module.exports = __webpack_public_path__ + "img/Efdot-Poster@2x.1ff9b51f.jpg";